import { Component, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { MatDialog } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { ToastrService } from 'ngx-toastr';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { ActivatedRoute } from '@angular/router';
import { InstallSpecDialogComponent } from '../../solution-onboarding/install-spec-dialog/install-spec-dialog.component';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { RouterSegments } from 'src/app/models/router-segments';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SolutionStatus } from 'src/app/models/service/solution-status';
import { KeyValueMap } from 'src/app/models/key-value-map';
import { Configuration } from 'src/app/models/configuration';
import { SidenavCapabilityComponent } from '../sidenav-capability/sidenav-capability.component';
import { ComponentService } from 'src/app/services/api/component.service';
import { CapabilityType } from 'src/app/models/service/capability';

@Component({
    selector: 'app-solution-version-details',
    templateUrl: './solution-version-details.component.html',
    styleUrls: ['./solution-version-details.component.scss'],
    standalone: false
})
export class SolutionVersionDetailsComponent  implements OnInit {
private destroyRef = inject(DestroyRef);

  data: any;
  configurationsMap: KeyValueMap<string, Configuration>;
  capabilities: any = {};
  displayedColumns = ['name', 'version'];
  breadcrumbItems: BreadcrumbItem[] = [];
  tenantId: string;
  RouterSegments = RouterSegments;
  tenant: string;
  isLoading = true;
  isLoadingheader = true;
  SolutionStatus = SolutionStatus;
  components: any;
  separator = 10;
  columns = [];
  componentTable: any;
  filteredMandatoryCapabilities = [];
  filteredOptionalCapabilities = [];
  componentData: any; 
  selectedTabIndex = 0;
  CapabilityType = CapabilityType;

  constructor(public dateTimeFormatService: DateTimeFormatService, private dialog: MatDialog,
    private solutionsService: SolutionsService, private toastrErrorService: ToastrErrorService,
    private sidenavService: SidenavService, private toastrService: CustomToastrService,
    private activatedRoute: ActivatedRoute, private authService: AuthService, private componentService: ComponentService) {
    
  }

  ngOnInit(): void {
    this.tenant = this.authService.principal.provider;
    this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.SOLUTIONS';
    this.tenantId = this.activatedRoute.snapshot.params.id;
    this.breadcrumbItems.push(
      {icon: 'assets/images/home_icon.svg', url: [RouterSegments.TENANT, this.tenantId] },
      {label: translate('TENANT_LAYOUT.MENU.SOLUTIONS'), url:[RouterSegments.TENANT, this.tenantId, RouterSegments.SOLUTION]});
    this.getSolutionVersionDetails();
  }

  getSolutionVersionDetails(): void {
    this.selectedTabIndex = 0;
    const solutionId = this.activatedRoute.snapshot.params.solutionId;
    const id = this.activatedRoute.snapshot.params.versionId;
    this.solutionsService.getSolutionVersion(solutionId, id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        if (data) {
          this.breadcrumbItems.push(
            {label: data?.name, url:[RouterSegments.TENANT, this.tenantId, RouterSegments.SOLUTION, data?.solutionId, RouterSegments.VERSIONS]},
            {label: translate('TENANT_SOLUTIONS.VIEW_BUILD_VERSION')});
            this.data = data;
            this.filteredMandatoryCapabilities = this.data?.capabilities?.filter(capability => capability.required === CapabilityType.MANDATORY);
            this.filteredOptionalCapabilities = this.data?.capabilities?.filter(capability => capability.required === CapabilityType.OPTIONAL);
            this.isLoading = false;
            this.isLoadingheader = false;

          this.solutionsService.getSolutionVersionManifestById(this.data.solutionId, this.data.id)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((component: any) => {
           if (component) {
            this.componentTable = component?.components;
            this.components = Object.keys(component?.components);
            const count = Math.round(this.components?.length / this.separator);
            for (let i = 0; i <= count; i++) {
              this.columns.push(i);
            }
           }
          });
        }
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  onClick(installSpec): void {
    this.dialog.open(InstallSpecDialogComponent, {
      minHeight: '342px',
      width: '630px',
      panelClass: 'flex-dialog',
      data: {
        title:  translate('SOLUTIONS.INSTALLATION_SPECIFICATION'),
        description: installSpec
      }
    });
  }

  openCreateConfigurationInstanceForm(name?: string, version?: string, category?: string) {
    this.isLoading = true;
    this.componentService.getComponentsNameVersion(name, version).subscribe(
      (data) => {
        this.componentData = data;
        this.componentData.category = category;         
        this.sidenavService.openInRightSidenav(SidenavCapabilityComponent, this.componentData);
        this.isLoading = false;
        this.selectedTabIndex = 1;
      }
    );
  }

  onClickSandbox(installSpec): void {
    this.dialog.open(InstallSpecDialogComponent, {
      minHeight: '342px',
      width: '630px',
      panelClass: 'flex-dialog',
      data: {
        title:  translate('SOLUTIONS.SANDBOX_SPECIFICATION'),
        description: installSpec
      }
    });
  }

}
